import { render, staticRenderFns } from "./echfation.vue?vue&type=template&id=1c5618c6&scoped=true&"
import script from "./echfation.vue?vue&type=script&lang=js&"
export * from "./echfation.vue?vue&type=script&lang=js&"
import style0 from "./echfation.vue?vue&type=style&index=0&id=1c5618c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5618c6",
  null
  
)

export default component.exports